module.exports = __webpack_public_path__ + "img/umivale_activa_hor_con_suma.873aea0d.svg";